<div class="page-header vis" [class.tab-page]="pageHeader.isTabPage" [style.padding-top]="pageHeaderPaddingTop">
  <div *ngIf="pageHeader.title !== null" class="page-block">
    <div class="row">
      <div class="col-lg-6">
        <h4>
          <em *ngIf="pageHeader.icon !== null" class="{{ pageHeader.icon }}"></em>
          <ng-container *ngIf="pageHeader.breadcrumbs.length <= 1; else breadCrumbs">
            {{ pageHeader.title }}
          </ng-container>
        </h4>
        <ng-template #breadCrumbs>
          <nav aria-label="breadcrumb" class="ml-2 d-inline-flex flex-wrap">
            <ol class="breadcrumb">
              <ng-container *ngFor="let breadCrumb of pageHeader.breadcrumbs">
                <li class="breadcrumb-item">
                  <a *ngIf="!breadCrumb.disabled; else disabledBreadCrumb" routerLink="{{ breadCrumb.url }}">
                    {{ breadCrumb.label }}
                  </a>
                  <ng-template #disabledBreadCrumb>
                    {{ breadCrumb.label }}
                  </ng-template>
                </li>
              </ng-container>
            </ol>
          </nav>
        </ng-template>
      </div>
      <div class="col-lg-1 text-right">
        <a
          *ngIf="pageHeader.fullScreenButton"
          class="btn ripple light"
          data-target="{{ pageHeader.fullScreenTargetElementId }}"
          appToggleFullScreen
        >
          <em class="text-white fas fa-expand-arrows-alt full-screen"></em>
        </a>
      </div>
      <div class="col-lg-5">
        <div class="text-right float-right padding-right-0 pl-3" *ngIf="showPageConfig !== -1 && !isPageConfigHidden">
          <div class="page-config-icon">
            <app-page-configuration class="text-right float-right" [pageHeader]="pageHeader"></app-page-configuration>
          </div>
        </div>
        <div class="text-right float-right pl-3" *ngIf="showFilterBarVisibilityButton">
          <app-filter-visibility-button></app-filter-visibility-button>
        </div>
      </div>
    </div>
  </div>
</div>
